import { memo } from "react";
import { Button } from "@/components/ui/button";

interface HashKeysEmptyStateProps {
  searchQuery: string;
  onClearSearch: () => void;
}

/**
 * Empty state component for when no hash keys are found
 */
const HashKeysEmptyState = memo<HashKeysEmptyStateProps>(
  ({ searchQuery, onClearSearch }) => (
    <div className="flex h-64 w-full items-center justify-center">
      <div className="text-center">
        <i className="ri-key-line mb-4 text-5xl text-gray-400"></i>
        <p className="mb-2 text-lg font-medium text-gray-600">
          No hash keys found
        </p>
        <p className="text-sm text-gray-500">
          {searchQuery ? "Try adjusting your search" : "No hash keys available"}
        </p>
        {searchQuery && (
          <Button
            onClick={onClearSearch}
            variant="default"
            className="mt-4 bg-blue-600 text-white hover:bg-blue-700"
          >
            Clear search
          </Button>
        )}
      </div>
    </div>
  ),
);

HashKeysEmptyState.displayName = "HashKeysEmptyState";

export default HashKeysEmptyState;
